import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DebugButtonComponent } from './components/debugger/debug-button.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, DebugButtonComponent]
})
export class AppComponent implements OnInit {
    /**
     * Constructor
     */
    constructor() {}

    /**
     * On init
     */
    ngOnInit(): void {
    }
}
